import { Box, Container, Link, Typography } from "@mui/material"

const Footer = () => {
  return(
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: '#1f1f1f',
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            style={{marginTop: 2, color: '#a1a1a1'}}
          >
            <Link href="https://linkedin.com/in/deddy-gunawan" target="_blank" color="inherit" underline="none">
              <i className="devicon-linkedin-plain-wordmark" style={{marginRight: 8, fontSize: 44}}></i>
            </Link>
            <Link href="https://github.com/gunawan98" target="_blank" color="inherit" underline="none">
              <i className="devicon-github-original-wordmark" style={{marginLeft: 8}}></i>
            </Link>
          </Typography>

          <Typography variant="subtitle2" display="block" align="center" style={{color: '#ffff'}}>
            &copy; {new Date().getFullYear()} Deddy Gunawan
          </Typography>
          <Typography variant="caption" display="block" align="center" style={{color: '#ffff'}}>
             E-Mail: deddyscareer@gmail.com
          </Typography>
          
        </Container>
      </Box>
    </>
  )
}

export default Footer